module.exports = __webpack_public_path__ + "img/hospitality.952d0571.jpg";